<template>
    <ul
            class="dropdown-menu dropdown-menu-right"
            :class="{'show': isVisible}"
            tabindex="-1"
            @focusin="onFocusin"
            @focusout="onFocusout"
    >
        <b-dropdown-group
                v-for="(section, index) in data"
                :key="'bdg' + index"
                :header="section.header"
                class="lx-header-search-list-group"
        >
            <b-dropdown-item
                    v-for="(item, index) in section.items"
                    :key="'bdi' + index"
                    :href="item.href"
                    :target="item.target"
                    class="lx-header-search-li"
                    :class="itemClass(item.variant)"
            >
                <img v-if="item.is_blocklist" src="/static/images/icons/reservation/blocklist_bg_24.svg" class="blocklist-item"/>
                <img v-if="item.is_vip" src="/static/images/icons/reservation/vip_bg_24.svg" class="blocklist-item"/>
                <span v-html="highlight(item.text)"></span>
            </b-dropdown-item>
        </b-dropdown-group>
    </ul>
</template>

<script>
    function sanitize(text) {
        return text.replace(/</g, '&lt;').replace(/>/g, '&gt;')
    }

    function escapeRegExp(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    }

    export default {
        name: 'HeaderSearchList',
        props: {
            show: {
                type: Boolean,
                default: false,
            },
            data: {
                type: Array,
                required: true,
                validator: d => d instanceof Array
            },
            query: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                isFocused: false,
            }
        },
        methods: {
            onFocusin() {
                this.isFocused = true;
            },
            onFocusout(event) {
                const relTgt = event.relatedTarget;
                if (relTgt && relTgt.parentNode && relTgt.parentNode.classList.contains('lx-header-search-li')) {
                    // Cancel blur
                    event.target.focus();
                    return;
                }
                this.isFocused = false;
            },
        },
        computed: {
            isVisible() {
                return this.show || this.isFocused;
            },
            itemClass() {
                return (variant) => {
                    return variant ? ` bg-${variant}` : '';
                };
            },
            highlight() {
                return (text) => {
                    text = sanitize(text);
                    if (this.query.length === 0) {
                        return text;
                    }
                    const re = new RegExp(this.escapedQuery, 'gi');
                    return text.replace(re, `<strong>$&</strong>`);
                };
            },
            escapedQuery() {
                return escapeRegExp(sanitize(this.query));
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import "~bootstrap/scss/_functions.scss";
    @import "~bootstrap/scss/_variables.scss";
    @import "~bootstrap/scss/mixins/_breakpoints.scss";

    @include media-breakpoint-down(md) {
        .dropdown-menu {
            position: static;
            width: calc(100vw - 2rem);
            overflow: hidden;
        }

        :dee(.dropdown-item) {
            max-width: calc(100vw - 5rem);
            overflow: hidden;
        }
    }

    @include media-breakpoint-up(lg) {
        .dropdown-menu {
            max-height: 80vh;
            overflow: auto;
        }

        .lx-header-search-li {
            max-width: 80vw;
            overflow: hidden;
        }
    }

    .lx-header-search-list-group {
        padding: 0 1rem;
    }

    .lx-header-search-li {
        border-radius: .125rem;
    }

    :deep(.bg-danger .dropdown-item) {
        background-color: #ff4444;
    }

    :deep(.bg-danger .dropdown-item:hover) {
        background-color: #cc0000;
    }

    :deep(.bg-danger .dropdown-item) {
        color: #f8f9fa;
    }

    :deep(.bg-warning .dropdown-item) {
        background-color: #ffbb33;
    }

    :deep(.bg-warning .dropdown-item:hover) {
        background-color: #ff8800;
    }

    :deep(.bg-success .dropdown-item) {
        background-color: #00c851;
    }

    :deep(.bg-success .dropdown-item:hover) {
        background-color: #007e33;
    }

    :deep(.bg-info .dropdown-item) {
        background-color: #33b5e5;
    }

    :deep(.bg-info .dropdown-item:hover) {
        background-color: #0099cc;
    }

    /*
      Overwriting bootstrap style
     */
    .dropdown-menu {
        border-radius: 4px !important;
        padding: .5rem;
    }

    :deep(.dropdown-item) {
        border-radius: .125rem;
        padding: .5rem;
    }

    :deep(.dropdown-item:hover, .dropdown-item:active) {
        background-color: #4285f4;
        -webkit-box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
        box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
        color: #ffffff !important;
    }

    :deep(.dropdown-header) {
        margin-bottom: 1rem;
        border-bottom: 1px solid #e0e0e0;
        padding: 1rem 0 .75rem 0;
        font-weight: 700;
        font-size: 1.1rem;
        text-transform: uppercase;
    }

    .blocklist-item {
        width: 25px;
        height: 25px;
    }
</style>
